<template>
  <div>
    <MapLibre host="https://maps.moh1024.com" :is_cdn="true"/>
  </div>
</template>

<script>

import MapLibre from '../MapLibre.vue';

export default {
  name: 'AppMobileCDN',
  components: {
    MapLibre,
  },
};
</script>